"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIframe = createIframe;
exports.destroyFrames = destroyFrames;
exports.setFrameVisibility = setFrameVisibility;
exports.resizeFrame = resizeFrame;
exports.waitUntilDocumentIsReady = waitUntilDocumentIsReady;
var tslib_1 = require("tslib");
var config_1 = require("../config");
function createIframe(_a) {
    var src = _a.src, id = _a.id, title = _a.title, hidden = _a.hidden, _b = _a.selector, selector = _b === void 0 ? "body" : _b, _c = _a.style, style = _c === void 0 ? config_1.defaultFrameStyle : _c;
    var frame = document.createElement("iframe");
    frame.id = id;
    frame.src = src;
    frame.title = title;
    frame.allowFullscreen = true;
    Object.keys(style).forEach(function (key) { return frame.style.setProperty(key, "".concat(style[key])); });
    if (hidden)
        frame.style.display = "none";
    if (frame.style.zIndex)
        frame.style.setProperty("z-index", config_1.defaultFrameStyle.zIndex);
    var documentElement = document.querySelector(selector) || document.getElementsByTagName("html")[0];
    if (!documentElement)
        return frame;
    documentElement.appendChild(frame);
    return frame;
}
function destroyFrames(_a) {
    var frame = _a.frame, selector = _a.selector;
    var documentElement = document.getElementsByTagName("body")[0] || document.getElementsByTagName("html")[0];
    if (selector)
        documentElement = document.querySelector(selector) || documentElement;
    if (!documentElement)
        return;
    if (!documentElement.contains(frame))
        return;
    try {
        documentElement.removeChild(frame);
    }
    catch (_) {
    }
}
function setFrameVisibility(_a) {
    var frame = _a.frame, isVisible = _a.isVisible;
    frame.style.setProperty("visibility", isVisible ? "visible" : "hidden");
}
function resizeFrame(_a) {
    var frame = _a.frame, config = _a.config;
    var width = config.width, height = config.height, props = tslib_1.__rest(config, ["width", "height"]);
    frame.style.setProperty("width", width);
    frame.style.setProperty("height", height);
    if (props.zIndex)
        frame.style.setProperty("z-index", props.zIndex);
    if (props.minHeight)
        frame.style.setProperty("min-height", props.minHeight);
    if (props)
        Object.keys(props).forEach(function (key) { return frame.style.setProperty(key, props[key]); });
}
function waitUntilDocumentIsReady() {
    return new Promise(function (resolve) {
        if (document.readyState === "complete" || document.readyState !== "loading") {
            resolve();
            return;
        }
        if (window.addEventListener) {
            window.addEventListener("DOMContentLoaded", function () { return resolve(); });
            window.addEventListener("onreadystatechange", function () {
                if (document.readyState === "loading")
                    return;
                resolve();
            });
            return;
        }
    });
}
